import EditNoteIcon from "@mui/icons-material/EditNote";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Alert, Box, Chip, Typography } from "@mui/material";
import {
  formatSuperAdminTermEditTimestamp,
  formatSuperAdminTermEditWarnings,
  superAdminTermEditSourceLabel,
} from "./superAdminTermEditNoteUtils";

const SuperAdminTermEditNoteCard = ({ edit }) => {
  if (!edit) return null;

  const warnings = formatSuperAdminTermEditWarnings(edit.warnings);
  const when = formatSuperAdminTermEditTimestamp(edit.timestamp);
  const sourceLabel = superAdminTermEditSourceLabel(edit.source);

  return (
    <Box
      className="border border-app-border rounded-2xl bg-app-surface-muted p-4 max-w-xl"
      sx={{ borderLeftWidth: 4, borderLeftColor: "warning.main" }}
    >
      <Box className="flex items-center gap-2 mb-2">
        <EditNoteIcon fontSize="small" color="warning" />
        <Chip label="Super-admin term edit" size="small" color="warning" variant="outlined" />
      </Box>

      <Typography variant="subtitle2" className="text-app-text font-semibold mb-2">
        {edit.termNumber ? `Term T${edit.termNumber}` : "Term schedule"} · {sourceLabel}
      </Typography>

      <Box component="dl" className="grid grid-cols-1 gap-1.5 m-0 text-sm">
        <Box className="flex gap-2">
          <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 88 }}>
            Performed by
          </Typography>
          <Typography component="dd" variant="body2" className="text-app-text m-0">
            {edit.actorName}
          </Typography>
        </Box>
        {when ? (
          <Box className="flex gap-2">
            <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 88 }}>
              When
            </Typography>
            <Typography component="dd" variant="body2" className="text-app-text m-0">
              {when}
            </Typography>
          </Box>
        ) : null}
        {edit.changes?.length > 0 ? (
          <Box className="flex flex-col gap-1">
            <Typography component="dt" variant="body2" color="text.secondary">
              What changed
            </Typography>
            <Box component="ul" className="m-0 pl-4 list-disc">
              {edit.changes.map((change, index) => (
                <Typography
                  component="li"
                  key={`${change.field || change.label}-${index}`}
                  variant="body2"
                  className="text-app-text"
                >
                  <strong>{change.label || change.field}</strong>: {change.from || "(empty)"} →{" "}
                  {change.to || "(empty)"}
                </Typography>
              ))}
            </Box>
          </Box>
        ) : null}
      </Box>

      {warnings.length > 0 ? (
        <Alert severity="warning" icon={<WarningAmberOutlinedIcon />} sx={{ mt: 2 }}>
          {warnings.map((line) => (
            <Typography key={line} variant="body2">
              {line}
            </Typography>
          ))}
        </Alert>
      ) : null}
    </Box>
  );
};

export default SuperAdminTermEditNoteCard;
